/* eslint-disable react-hooks/exhaustive-deps */
import React, { HTMLProps, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { IAppState } from 'src/store';
import cn from 'classnames';
import { Navigator, Toastify } from 'src/services';

import { modalActions } from 'src/redux/modalRedux';
import { MODAL_TYPES } from 'src/appConfig/modal';
import './styles.scss';
import UserDetailItem from './UserDetailItem/UserDetailItem';
import Button from 'src/components/common/Button';
import { User } from 'src/containers/ManageUsers/type';
import { YesNoModalData } from 'src/components/Modal/YesNoModal';
import { Icon, Text, View } from 'src/components/common';
import { usersActions } from 'src/redux/usersRedux';
import { useParams } from 'react-router';
import { PATHS } from 'src/appConfig/paths';
import Loading from 'src/components/Loading';
import NewUser from '../NewUser';
import { getUserPositionDisplay } from 'src/utils';

interface ParamTypes {
  id: string;
}
const UserDetail: React.FC<Props> = ({
  user,
  className,
  showModal,
  closeModal,
  onGetUserById,
  onDeleteUserById,
  ...props
}) => {
  const { id } = useParams<ParamTypes>();
  const [recordUser, setRecordUser] = useState<User>();
  const [isLoading, setIsLoading] = useState(true);
  const [isShowEdit, setIsShowEdit] = useState(false);

  useEffect(() => {
    if (id) {
      onGetUserById({ id }, getUserDetailSuccess, getUserDetailFailed);
    } else handleBackToPrevious();
  }, []);

  const handleBackToPrevious = () => {
    Navigator.navigate(PATHS.ManageUsers);
  };
  const getUserDetailSuccess = (user: User) => {
    setRecordUser(user);
    setIsLoading(false);
  };

  const getUserDetailFailed = () => {
    setIsLoading(false);
  };

  const handleConfirmDeleteUser = () => {
    onDeleteUserById(
      { id: id },
      res => {
        Toastify.success('Delete User successfully');
        closeModal();
        handleBackToPrevious();
      },
      error => {
        Toastify.error('Delete User failure');
        closeModal();
      },
    );
  };

  const handleOpenDeleteModal = () => {
    showModal({
      type: MODAL_TYPES.YES_NO_MODAL,
      data: {
        title: 'Delete User',
        message: 'Are you sure that you want to delete this user?',
        onOk: handleConfirmDeleteUser,
        onCancel: closeModal,
      } as YesNoModalData,
    });
  };
  const handleOpenEditModal = () => {
    setIsShowEdit(true);
  };

  const handleCloseEdit = (user?: User) => {
    if (user) {
      setRecordUser(user);
    }
    setIsShowEdit(false);
  };

  return (
    <View>
      {isShowEdit && <NewUser user={recordUser} onClose={handleCloseEdit} />}
      {!!recordUser?.id ? (
        <View className="container" style={{ width: '100%' }}>
          <Button
            variant="text"
            className={'back-previous-page mt-40 mb-20'}
            icon={<Icon name={'ic_arrow_left'} />}
            onClick={() => {
              handleBackToPrevious();
            }}>
            VIEW ALL USERS
          </Button>
          <View isRow justify="space-between" className="mb-40">
            <Text size={36}>User Details</Text>
            <View isRow justify="flex-end">
              <Button style={{ right: '10px' }} variant="outline" onClick={handleOpenDeleteModal}>
                DELETE USER
              </Button>
              <Button onClick={handleOpenEditModal} variant="secondary">
                EDIT
              </Button>
            </View>
          </View>
          <View className={cn('cmp-user-detail', className)} {...props}>
            <View className="cmp-user-detail__row mb-16">
              <UserDetailItem
                className="mb-16"
                label="Name"
                text={`${recordUser.firstName ?? '--'} ${recordUser.lastName ?? '--'}`}
              />
              <UserDetailItem
                style={{ textTransform: 'capitalize' }}
                label="User Role"
                text={getUserPositionDisplay(recordUser.role)}
              />
            </View>
            <View className="cmp-user-detail__row mb-16">
              <UserDetailItem className="mb-16" label="Phone Number" text={recordUser.mobile ?? '--'} />
              <UserDetailItem label="Email" text={recordUser.email} />
            </View>
            <View className="cmp-user-detail__row mb-16">
              <UserDetailItem label="Company/Law Firm" text={recordUser.companyOrLawFirm} />
            </View>
          </View>
        </View>
      ) : (
        <View isRow justify="center" className="mt-72">
          {isLoading && (
            <View className="ctn-loading">
              <Loading loadingStyle={2} variant="primary" />
            </View>
          )}
        </View>
      )}
    </View>
  );
};

type Props = ReturnType<typeof mapStateToProps> &
  typeof mapDispatchToProps &
  HTMLProps<HTMLDivElement> & {
    user: User;
  };

const mapStateToProps = (state: IAppState) => ({});

const mapDispatchToProps = {
  showModal: modalActions.showModal,
  closeModal: modalActions.closeModal,
  onGetUserById: usersActions.getUserById,
  onDeleteUserById: usersActions.deleteUserById,
};
export default connect(mapStateToProps, mapDispatchToProps)(UserDetail);
